module.exports = __webpack_public_path__ + "static/media/GraduateDetail.0e7708e1.svg";